export const LOAD_REQUESTED = "INPUT_WIDGET/LOAD_REQUESTED";
export const LOAD_SUCCESS = "INPUT_WIDGET/LOAD_SUCCESS";
export const LOAD_FAIL = "INPUT_WIDGET/LOAD_FAIL";

export default (state = {}, { type }) => {
    switch (type) {
    case LOAD_REQUESTED: {
        return state;
    }
    case LOAD_SUCCESS: {
        return state;
    }
    case LOAD_FAIL: {
        return state;
    }
    default: return state;
    }
};

export const requestLoadInputWidget = data => ({ type: LOAD_REQUESTED, data });
export const successLoadInputWidget = data => ({ type: LOAD_SUCCESS, data });
export const failLoadInputWidget = data => ({ type: LOAD_FAIL, data });
